<template>
  <div class="powerText">
    <!-- 父容器：row 栅格行 -->
    <section class="row m-0">
      <!-- 左侧：大屏占4 → col-lg-4 (lg=大屏) -->
      <div class="left entext col-lg-4">
        <img src="@/assets/images/icon1.gif" alt="" />
      </div>
      <!-- 右侧：大屏占6 → col-lg-6 -->
      <div class="right entext col-lg-8">
        <img :src="$t('homepage.sztext')" alt="" />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'powerText',
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.powerText {
  padding: 3rem 0 3rem 0;
}

.left img {
  border-radius: 10px;
}
.right {
  text-align: left;
  margin-top: 40px;
}
</style>
